import React from "react";
import {AiFillInfoCircle} from 'react-icons/ai';

let ErrorLabel = ({text}) => <label className='validation-text'>
    <AiFillInfoCircle/>
    {text}
</label>

export default ErrorLabel